import { CloseOutlined } from '@ant-design/icons';
import React from 'react';

const SelectRemoveIcon = () => <CloseOutlined name="select-remove-item-icon" />;

export default SelectRemoveIcon;
